<template>
  <div class="hearing-aid-brands">
    <HeroBanner
        :background-image="bannerImage"
        title="보청기 브랜드"
        sub-title="첨단 검사장비로 청력을 종합적으로 진단하여 <br>
        검증된 글로벌 브랜드의 보청기를 <br>
        전국 가격 정찰제로 제공합니다."
    />

    <!-- 로딩 상태 -->
    <div v-if="brandsLoading" class="loading-message">
      브랜드 정보를 불러오는 중...
    </div>

    <!-- 에러 상태 -->
    <div v-else-if="brandsError" class="error-message">
      {{ brandsError }}
    </div>

    <!-- 브랜드 섹션 -->
    <div v-else class="brands-sections">
      <section
        v-for="brand in brands"
        :key="brand.id"
        class="brand-item"
      >
        <div class="brand-item__logo">
          <img
            :src="brand.logo"
            :alt="brand.name"
            @error="handleImageError"
          >
        </div>
        <div class="brand-item__content">
          <h3 class="brand-item__title">{{ brand.name }}</h3>
          <p class="brand-item__description">
            {{ brand.description }}
          </p>

          <!-- 상세 이미지가 있는 경우 표시 -->
          <div v-if="brand.detailImages && brand.detailImages.length > 0" class="brand-item__details">
            <img
              v-for="(image, index) in brand.detailImages"
              :key="index"
              :src="image"
              :alt="`${brand.name} 상세 이미지 ${index + 1}`"
              class="detail-image"
              @error="handleImageError"
            >
          </div>

          <!-- 외부 링크가 있는 경우 표시 -->
<!--          <a-->
<!--            v-if="brand.outlink"-->
<!--            :href="brand.outlink"-->
<!--            target="_blank"-->
<!--            rel="noopener noreferrer"-->
<!--            class="brand-item__link"-->
<!--          >-->
<!--            자세히 보기 →-->
<!--          </a>-->
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import brandsMixin from "@/mixins/brandsMixin";
import bannerBg from '@/assets/images/heros/02-top-img.png';
import bannerBg2 from '@/assets/images/heros/02-top-img@2x.png';

export default {
  name: 'HearingAidBrands',
  components: { HeroBanner },
  mixins: [brandsMixin],
  data() {
    return {
      bannerImage: [bannerBg, bannerBg2],
    };
  },
  async created() {
    await this.loadBrands();
  },
  methods: {
    handleImageError(event) {
      event.target.style.display = 'none';
    }
  }
};
</script>

<style scoped lang="scss">
.hearing-aid-brands {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  background: #fff;
}

.loading-message,
.error-message {
  padding: 60px 20px;
  text-align: center;
  font-size: 16px;
}

.loading-message {
  color: #666;
}

.error-message {
  color: #d32f2f;
}

.brands-sections {
  padding: 55.8px 0 0;
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.brand-item {
  display: flex;
  flex-direction: column;
  gap: 27.9px;

  &__logo {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;

    img {
      display: block;
      height: auto;
      max-width: 100%;
      max-height: 120px;
      object-fit: contain;
    }
  }

  &__content {
    padding: 0 36px;
    display: flex;
    flex-direction: column;
    gap: 16.74px;
  }

  &__title {
    font-family: 'Noto Sans KR', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 40px;
    letter-spacing: -0.05em;
    color: #222222;
    margin: 0;
  }

  &__description {
    font-family: 'Noto Sans KR', sans-serif;
    font-style: normal;
    font-weight: 350;
    font-size: 16px;
    line-height: 28px;
    letter-spacing: -0.04em;
    color: #666666;
    margin: 0;
    white-space: pre-line;
  }

  &__details {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 8px;

    .detail-image {
      width: 100%;
      height: auto;
      object-fit: contain;
      border-radius: 4px;
    }
  }

  &__link {
    display: inline-block;
    margin-top: 8px;
    color: #0066cc;
    text-decoration: none;
    font-weight: 500;
    font-size: 15px;
    transition: color 0.2s;

    &:hover {
      color: #004499;
      text-decoration: underline;
    }
  }
}

@media (max-width: 768px) {
  .brands-sections {
    padding: 40px 0 0;
    gap: 40px;
  }

  .brand-item {
    gap: 20px;

    &__logo img {
      max-height: 100px;
    }

    &__content {
      padding: 0 20px;
      gap: 12px;
    }

    &__title {
      font-size: 22px;
      line-height: 36px;
    }

    &__description {
      font-size: 15px;
      line-height: 26px;
    }

    &__link {
      font-size: 14px;
    }
  }
}
</style>